/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Ocr_FailedInputs */



/**
* | output |
* | --- |
* | "OCR processing failed: {error}" |
*
* @param {Ocr_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_failed = /** @type {((inputs: Ocr_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec du traitement OCR : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`OCR-Verarbeitung fehlgeschlagen: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Elaborazione OCR non riuscita: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сбой обработки OCR: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`El procesamiento OCR falló: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`OCR 处理失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`OCR処理に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`OCR प्रोसेसिंग विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha no processamento OCR: ${i?.error}`)
	return /** @type {LocalizedString} */ (`OCR processing failed: ${i?.error}`)
});